/**
 * Returns the difference in months, not considering start day
 *
 * @example
 * differenceInMonths(new Date('2020-01-15'), new Date('2020-01-15')) === 1
 */
export function differenceInMonths(d1: Date, d2: Date): number {
	return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}
